export const MY_PAY_SLIP_EMPLOYEE_ID = 'emp-s01';
export const MY_CLOCKING_EMPLOYEE_ID = 'emp-001';

export function useMyPaySlipEmployeeId(): string {
  return MY_PAY_SLIP_EMPLOYEE_ID;
}

export function useMyClockingEmployeeId(): string {
  return MY_CLOCKING_EMPLOYEE_ID;
}
